var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/magazine-edit.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-33d44394!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/magazine-edit.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MagazineEdit.vue
// module id = 622
// module chunks = 1